var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnonymity = function SvgAnonymity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4649 6C11.2471 6.37641 10.9698 6.71404 10.6458 7H5.35418C5.03018 6.71404 4.75287 6.37641 4.53513 6H11.4649Z",
    fill: "#676D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.874 5C11.9562 4.68038 12 4.3453 12 4H4C4 4.3453 4.04375 4.68038 4.12602 5H11.874Z",
    fill: "#676D73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4649 2C11.6439 2.30951 11.7827 2.64523 11.874 3H4.12602C4.21733 2.64523 4.35609 2.30951 4.53513 2H11.4649Z",
    fill: "#676D73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6458 1C9.94069 0.377637 9.01445 0 8 0C6.98555 0 6.05931 0.377637 5.35418 1H10.6458Z",
    fill: "#676D73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C18 11.32 17.04 10.06 15.67 9.13C18.43 9.53 22 10.82 22 13V16H18V13Z",
    fill: "#676D73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C16.21 8 18 6.21 18 4C18 1.79 16.21 0 14 0C13.53 0 13.09 0.0999998 12.67 0.24C13.5 1.27 14 2.58 14 4C14 5.42 13.5 6.73 12.67 7.76C13.09 7.9 13.53 8 14 8Z",
    fill: "#676D73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.005 10C4.67 9.33416 6.66667 9 8 9C9.33333 9 11.33 9.33416 12.995 10H3.005Z",
    fill: "#676D73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8252 11C15.2135 11.2998 15.5262 11.6331 15.7311 12H0.268915C0.473772 11.6331 0.786455 11.2998 1.17476 11H14.8252Z",
    fill: "#676D73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V13H16V14H0Z",
    fill: "#676D73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15V16H16V15H0Z",
    fill: "#676D73"
  })));
};
export default SvgAnonymity;